import React, {type ReactElement} from "react";

import translate from "/src/utils/translate";
import {css} from "/src/utils/utils";

import Icon from "../icon/Icon";
import LinkTag from "../buttons/link-tag/LinkTag";
import FacebookIcon from "/src/svg/facebook.svg";
import LinkedInIcon from "/src/svg/linkedin.svg";
import TwitterIcon from "/src/svg/twitter.svg";

import * as styles from "./social-icons.module.scss";

export interface SocialIcon {
  icon: "facebook" | "linkedin" | "twitter";
  url: string;
}

const LABEL: Record<string, string> = {
  facebook: "Facebook",
  twitter: "Twitter",
  linkedin: "Linkedin",
};

const ICON: Record<string, any> = {
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  linkedin: LinkedInIcon,
};

interface SocialIconsProps {
  iconList: Array<SocialIcon>;
  wrapperClasses?: string;
  iconClasses?: string;
  id: string;
}

const SocialIcons = (props: SocialIconsProps): ReactElement | null => {
  const {iconList, iconClasses, wrapperClasses, id} = props;

  return (
    <ul
      aria-label={translate("Follow us")}
      className={css(styles.socialIcons, wrapperClasses!)}
    >
      {iconList.map((item: SocialIcon) => {
        const label = `${translate("Follow us on")} ${LABEL[item.icon]}`;
        return (
          <li
            key={`${id}-${item.icon}`}
            className={styles.socialIcons__listItem}
          >
            <LinkTag
              classes={styles.socialIcons__link}
              ariaLabel={label}
              href={item.url}
            >
              <Icon
                classes={css(styles.socialIcons__link__icon, iconClasses!)}
                svg={ICON[item.icon]}
                role="presentation"
              />
            </LinkTag>
          </li>
        );
      })}
    </ul>
  );
};

export default SocialIcons;
